(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", init);

  function init() {
    const root = document.getElementById("product-swatch-root");
    const productHandle = root?.dataset.productHandle || "";

    initFrameOnlyLogic();
    initTitleFallback();
    initLiteDeskLogic(productHandle);
    initLegendUpdates();
  }

  /* ------------------------------------------------------------
     FRAME ONLY / NO DESKTOP LOGIC
  ------------------------------------------------------------ */
  function initFrameOnlyLogic() {
    const sizeInputs = document.querySelectorAll(
      'input[type="radio"][name="Desk Top Size(cm)"]'
    );
    const colorInputs = document.querySelectorAll(
      'input[type="radio"][name="Desk Top Colour"]'
    );

    if (!sizeInputs.length || !colorInputs.length) return;

    let lastSizeValue =
      document.querySelector('input[name="Desk Top Size(cm)"]:checked')
        ?.value || "";

    function selectByValue(inputs, value) {
    const input = [...inputs].find(i => i.value === value);

    if (input && !input.checked && !input.disabled) {
      input.click();
    }
  }

    function getFirstNonFrameSize() {
      return [...sizeInputs].find(i => i.value !== "Frame Only")?.value || null;
    }

    function isFrameOnly(value) {
      return value?.trim().toLowerCase() === "frame only";
    }

    /* Init */
    if (isFrameOnly(lastSizeValue)) {
      selectByValue(colorInputs, "No Desktop");
    }

    /* Size change */
    sizeInputs.forEach(input => {
      input.addEventListener("change", () => {

        // ✅ store only real sizes (NOT Frame Only)
        if (!isFrameOnly(input.value)) {
          lastSizeValue = input.value;
        }

        if (isFrameOnly(input.value)) {
          selectByValue(colorInputs, "No Desktop");
        } else {
          const currentColor = [...colorInputs].find(i => i.checked)?.value;

          if (currentColor === "No Desktop") {
          // Try White first
          let selected = selectByValue(colorInputs, "White");

          // If White doesn't exist, try Arctic White
          if (!selected) {
            selectByValue(colorInputs, "Arctic White");
          }
        }
        }
      });
    });
    
    /* Color change */
    colorInputs.forEach(input => {
      input.addEventListener("change", () => {

        const currentSize =
          [...sizeInputs].find(i => i.checked)?.value || "";

        if (
          isFrameOnly(currentSize) &&
          input.value !== "No Desktop"
        ) {
          // ✅ select 2nd option (index 1)
          const firstRealSize = [...sizeInputs].find(
            i => i.value !== "Frame Only" && !i.disabled
          );

          if (firstRealSize) {
            firstRealSize.click();
          }
        }
      });
    });
  
  }

  /* ------------------------------------------------------------
     RADIO TITLE FALLBACK
  ------------------------------------------------------------ */
  function initTitleFallback() {
    document
      .querySelectorAll('input[type="radio"][name="Desk Top Colour"]')
      .forEach(radio => {
        if (!radio.hasAttribute("title")) {
          radio.setAttribute("title", radio.value);
        }
      });
  }

  /* ------------------------------------------------------------
     YO-YO DESK LITE LOGIC
  ------------------------------------------------------------ */
  function initLiteDeskLogic(productHandle) {
    if (!productHandle.includes("yo-yo-desk-lite")) return;

    const sizeInputs = document.querySelectorAll(
      'input[type="radio"][name="Size"]'
    );
    const colorInputs = document.querySelectorAll(
      'input[type="radio"][name="Color"]'
    );

    if (!sizeInputs.length || !colorInputs.length) return;

    function updateColors() {
      const checkedSize =
        [...sizeInputs].find(i => i.checked)?.value || "";
      const isLiteS = checkedSize === "LITE [S]: 80 x 32cm";

      const whiteInput = [...colorInputs].find(i => i.value === "White");
      if (!whiteInput) return;

      const label = whiteInput.nextElementSibling;

      whiteInput.disabled = isLiteS;

      if (label) {
        label.classList.toggle("disabled", isLiteS);
        label.style.pointerEvents = isLiteS ? "none" : "";
        label.style.opacity = isLiteS ? "0.4" : "";
      }

      if (isLiteS && whiteInput.checked) {
        const firstAvailable = [...colorInputs].find(i => !i.disabled);
        if (firstAvailable) firstAvailable.checked = true;
      }
    }

    updateColors();
    sizeInputs.forEach(i => i.addEventListener("change", updateColors));
  }

  /* ------------------------------------------------------------
     LEGEND VALUE UPDATES
  ------------------------------------------------------------ */
  function initLegendUpdates() {
    function normalize(name) {
      return name.replace(/^options\[|\]$/g, "");
    }

    function clear() {

  document.querySelectorAll(".selected-value").forEach(e => {

    // keep oceanic placeholder
    if (e.classList.contains("oceanic-selected-value")) {
      e.textContent = "";
      return;
    }

    e.remove();
  });
}

    function updateLegend(optionName, optionValue) {
      const legends = document.querySelectorAll("legend .form__label.h6");

      const legend = [...legends].find(
        l =>
          l.textContent.replace(":", "").trim().toLowerCase() ===
          optionName.toLowerCase()
      );

      if (!legend || !optionValue) return;

      const allowedSizes = ["100x60", "120x70"];

      if (
        optionName.toLowerCase() === "desk top size(cm)" &&
        allowedSizes.includes(optionValue)
      ) {
        optionValue += " (No Portholes)";
      }

      if (
        optionName.toLowerCase() === "desk top colour" &&
        optionValue.toLowerCase() === "no desktop"
      ) {
        return;
      }

      const oceanicValues = [
  "Paddle",
  "Riptide",
  "Bay",
  "Barrier",
  "Jetsam",
  "Sea",
  "Neptune",
  "Atoll",
  "Seafarer",
  "Aquatic",
  "Abyss"
];

if (
  optionName.toLowerCase() === "eco fabric camira x2" &&
  oceanicValues.includes(optionValue)
) {

  const oceanicLegend = document.querySelector(
    ".oceanic-selected-value"
  );

  if (oceanicLegend) {
    oceanicLegend.textContent = optionValue;
  }
  

  return;
}

const span = document.createElement("span");
span.className = "selected-value";
span.style.marginLeft = "6px";
span.textContent = optionValue;

legend.appendChild(span);
    }

    function updateAll() {
      clear();
      document
        .querySelectorAll('input[type="radio"]:checked')
        .forEach(input => {
          updateLegend(normalize(input.name), input.value.trim());
        });
    }

    document.addEventListener("change", e => {
      if (e.target.matches('input[type="radio"]')) {
        updateAll();
      }
    });

    updateAll();
  }
})();

function updateSeatColourAvailability() {
  const baseOption = document.querySelector(
    'input[name="Base & Column"]:checked'
  );

  const lightGreenInput = document.querySelector(
    'input[name="Seat Colour"][value="Light Green"]'
  );

  const lightGreenLabel = lightGreenInput
    ? lightGreenInput.nextElementSibling
    : null;

  if (!baseOption || !lightGreenLabel) {
    return;
  }

  if (baseOption.value === "Black / Natural Wood") {
    lightGreenLabel.classList.add("disabled-option");
    lightGreenInput.disabled = true;

  } else {

    lightGreenLabel.classList.remove("disabled-option");
    lightGreenInput.disabled = false;
  }
}

/* ---------- PAGE LOAD FIX ---------- */
document.addEventListener("DOMContentLoaded", () => {

  // small delay because Shopify updates options after load
  setTimeout(() => {
    updateSeatColourAvailability();
  }, 200);

  // listen for changes
  document.querySelectorAll('input[name="Base & Column"]').forEach(input => {
    input.addEventListener("change", function () {
      updateSeatColourAvailability();
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {

  const oceanicLabels = document.querySelectorAll(
    '.oceanic-option .swatch-element__text'
  );

  oceanicLabels.forEach(label => {

    label.addEventListener("click", function () {

      const value = this.getAttribute("title");

      // ORIGINAL hidden Shopify variant radio
      const originalInput = document.querySelector(
        '.all-variant[data-name="Eco Fabric CAMIRA X2"] input[value="' + value + '"]'
      );

      if (!originalInput) return;

      // uncheck all first
      document.querySelectorAll(
        '.all-variant[data-name="Eco Fabric CAMIRA X2"] input[type="radio"]'
      ).forEach(radio => {
        radio.checked = false;
      });

      // check correct one
      originalInput.checked = true;

      // IMPORTANT Shopify triggers
      originalInput.click();

      originalInput.dispatchEvent(
        new Event('input', { bubbles: true })
      );

      originalInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );

    });

  });

});

// Pod options wood 

document.addEventListener("DOMContentLoaded", function () {

    const fieldset = document.querySelector('fieldset[data-name="Standard"]');
    if (!fieldset) return;

    // Prevent running twice
    if (fieldset.dataset.grouped === "true") return;
    fieldset.dataset.grouped = "true";

    const standardColours = [
        "Traffic White",
        "Light Grey",
        "Cashmere Grey",
        "Anthracite",
        "Black"
    ];

    const woodgrainColours = [
        "Birch",
        "Windsor Oak",
        "Light Sorano Oak",
        "Walnut",
        "Halifax Oak"
    ];

    const originalLegend = fieldset.querySelector("legend");
    if (!originalLegend) return;

    // Create sections
    const standardSection = document.createElement("div");
    standardSection.className = "standard-section";

    const woodSection = document.createElement("div");
    woodSection.className = "wood-section";

    // Create groups
    const standardGroup = document.createElement("div");
    standardGroup.className = "standard-group";

    const woodLegend = document.createElement("legend");
    woodLegend.innerHTML = `
        <span class="form__label h6">
            Woodgrain:
        </span>
    `;

    const woodGroup = document.createElement("div");
    woodGroup.className = "woodgrain-group";

    // Move original legend
    standardSection.appendChild(originalLegend);
    standardSection.appendChild(standardGroup);

    // Build Woodgrain section
    woodSection.appendChild(woodLegend);
    woodSection.appendChild(woodGroup);

    // Get all labels
    const labels = [...fieldset.querySelectorAll("label.swatch-element__text")];

    labels.forEach(label => {

        const title = (label.getAttribute("title") || "").trim();

        const input = fieldset.querySelector(
            `input[id="${label.getAttribute("for")}"]`
        );

        if (!input) return;

        if (standardColours.includes(title)) {

            standardGroup.appendChild(input);
            standardGroup.appendChild(label);

        } else if (woodgrainColours.includes(title)) {

            woodGroup.appendChild(input);
            woodGroup.appendChild(label);

        }

    });

    // Append sections
    fieldset.appendChild(standardSection);
    fieldset.appendChild(woodSection);

    const standardLabel = originalLegend.querySelector(".form__label");
    const woodLabel = woodLegend.querySelector(".form__label");

    // CHANGED: accepts an optional value. When called with no argument
    // (only on initial page load) it falls back to querying :checked.
    function updateHeadings(value) {

        if (value === undefined) {
            const checked = fieldset.querySelector('input[type="radio"]:checked');
            if (!checked) return;
            value = checked.value;
        }

        // Remove previous selected values
        originalLegend.querySelector(".selected-value")?.remove();
        woodLegend.querySelector(".selected-value")?.remove();

        const span = document.createElement("span");
        span.className = "selected-value";
        span.style.marginLeft = "6px";
        span.textContent = value;

        if (standardColours.includes(value)) {

            standardLabel.appendChild(span);

        } else if (woodgrainColours.includes(value)) {

            woodLabel.appendChild(span);
        }
    }
    // Initial load
    // Initial load
    updateHeadings();

    // Normal update on our own change event
    fieldset.addEventListener("change", function (e) {
        if (e.target.type !== "radio") return;
        updateHeadings(e.target.value);
    });

    // NEW: self-healing watcher. Some other shared script on this site also
    // writes into these same two legends and can overwrite our correct
    // value AFTER we've set it. Instead of racing it, we watch both
    // legends forever — the instant anything puts the wrong colour in the
    // wrong legend, we move it to the right one.
    function fixIfWrong() {
        const stdSpan = originalLegend.querySelector(".selected-value");
        const woodSpan = woodLegend.querySelector(".selected-value");

        if (stdSpan && woodgrainColours.includes(stdSpan.textContent.trim())) {
            woodLegend.querySelector(".selected-value")?.remove();
            woodLabel.appendChild(stdSpan);
        }

        if (woodSpan && standardColours.includes(woodSpan.textContent.trim())) {
            originalLegend.querySelector(".selected-value")?.remove();
            standardLabel.appendChild(woodSpan);
        }
    }

    const legendObserver = new MutationObserver(fixIfWrong);
    legendObserver.observe(originalLegend, { childList: true, subtree: true });
    legendObserver.observe(woodLegend, { childList: true, subtree: true });
  
});

function prepareVariantLabels() {
  document.querySelectorAll(
    '.all-variant[data-name="Exterior Colour"] legend .form__label.h6, .all-variant[data-name="Interior Sheet Colour"] legend .form__label.h6, .all-variant[data-name="Carpet"] legend .form__label.h6'
  ).forEach(function(label) {
    if (label.querySelector('.variant-label-text')) return;

    const selectedValue = label.querySelector('.selected-value');

    if (!selectedValue) return;

    Array.from(label.childNodes).forEach(function(node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        const wrapper = document.createElement('span');
        wrapper.className = 'variant-label-text';
        wrapper.textContent = node.textContent.trim();
        node.replaceWith(wrapper);
      }
    });
  });
}

function updateVariantLegendHeights() {
  prepareVariantLabels();

  const containers = document.querySelectorAll(
    'variant-radios:has(.all-variant[data-name="Exterior Colour"]):has(.all-variant[data-name="Interior Sheet Colour"]):has(.all-variant[data-name="Carpet"])'
  );

  containers.forEach(function(container) {
    const variants = Array.from(container.querySelectorAll(
      '.all-variant[data-name="Exterior Colour"], .all-variant[data-name="Interior Sheet Colour"], .all-variant[data-name="Carpet"]'
    ));

    variants.forEach(function(variant) {
      const legend = variant.querySelector('legend');

      if (legend) {
        legend.style.height = 'auto';
      }
    });

    const rows = [];

    variants.forEach(function(variant) {
      const legend = variant.querySelector('legend');

      if (!legend) return;

      const rect = variant.getBoundingClientRect();

      let row = rows.find(function(item) {
        return Math.abs(item.top - rect.top) < 5;
      });

      if (!row) {
        row = {
          top: rect.top,
          legends: []
        };

        rows.push(row);
      }

      row.legends.push(legend);
    });

    rows.forEach(function(row) {
      let maxHeight = 0;

      row.legends.forEach(function(legend) {
        const height = legend.getBoundingClientRect().height;

        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      row.legends.forEach(function(legend) {
        legend.style.height = maxHeight + 'px';
      });
    });
  });
}

function runVariantLegendHeightUpdate() {
  requestAnimationFrame(function() {
    updateVariantLegendHeights();
  });
}

window.addEventListener('load', runVariantLegendHeightUpdate);
window.addEventListener('resize', runVariantLegendHeightUpdate);
document.addEventListener('DOMContentLoaded', runVariantLegendHeightUpdate);

const variantObserver = new MutationObserver(function() {
  runVariantLegendHeightUpdate();
});

variantObserver.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});